// extracted by mini-css-extract-plugin
export default {"helpIcon":"src-feature-config-opportunity-form-__form_helpIcon"};